var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#F5772F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3248 22.6752L17.4406 30.5594M18.2915 24.8375L14.4297 23.9253C14.0048 23.825 13.8553 23.2975 14.1631 22.9886L17.2343 19.9174C17.4406 19.7111 17.7205 19.5929 18.0138 19.5907L21.4764 19.5606M25.8377 15.5984C28.4149 17.3559 30.6441 19.5851 32.4016 22.1623M23.1614 29.7085L24.0736 33.5703C24.1739 33.9952 24.7014 34.1447 25.0103 33.8369L28.0814 30.7657C28.2878 30.5594 28.406 30.2795 28.4082 29.9862L28.4383 26.5236M33.0629 20.3501L33.9639 16.0144C34.2093 14.8345 33.1655 13.7907 31.9856 14.0361L27.6499 14.9371C26.373 15.2025 25.2021 15.8348 24.281 16.7571L20.7236 20.3133C19.3665 21.6705 18.4833 23.4302 18.2045 25.3293L18.1922 25.4107C18.016 26.6229 18.4219 27.8462 19.2873 28.7127C20.1527 29.5781 21.3771 29.984 22.5893 29.8067L22.6707 29.7944C24.5698 29.5167 26.3295 28.6324 27.6867 27.2753L31.2429 23.719C32.1652 22.7979 32.7975 21.627 33.0629 20.3501Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.f3bc9b38278f0dcb25cf1e84c8c60638.svg";
export { ForwardRef as ReactComponent };